// extracted by mini-css-extract-plugin
module.exports = {"divider":"BillingReport_divider__ukm6W","title":"BillingReport_title__3SCdB","spacer":"BillingReport_spacer__3uT4-","rightBtnCol":"BillingReport_rightBtnCol__1je2t"};